import { render } from "./AltTabSwitcher.vue?vue&type=template&id=14b62046"
import script from "./AltTabSwitcher.vue?vue&type=script&lang=js"
export * from "./AltTabSwitcher.vue?vue&type=script&lang=js"

import "./AltTabSwitcher.vue?vue&type=style&index=0&id=14b62046&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/AltTabSwitcher.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "14b62046"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('14b62046', __exports__)) {
    api.reload('14b62046', __exports__)
  }
  
  module.hot.accept("./AltTabSwitcher.vue?vue&type=template&id=14b62046", () => {
    api.rerender('14b62046', render)
  })

}


export default __exports__